import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/debug',
    name: 'debug',
    component: () => import('../views/DebugView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/study',
    name: 'study',
    component: () => import('../views/StudyView.vue'),
  },
  {
    path: '/study/prs',
    name: 'study-prs',
    component: () => import('../views/StudyPrsView.vue'),
  },
  {
    path: '/review',
    name: 'review',
    component: () => import('../views/ReviewView.vue'),
  },
  {
    path: '/words',
    name: 'words',
    component: () => import('../views/WordListView.vue'),
  },
  {
    path: '/words/create',
    name: 'words-create',
    component: () => import('../views/WordDetailView.vue'),
  },
  {
    path: '/words/:id',
    name: 'words-edit',
    component: () => import('../views/WordDetailView.vue'),
  },
  {
    path: '/topics',
    name: 'topics',
    component: () => import('../views/TopicListView.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
